import { useQuery, useMutation, QueryClient } from '@tanstack/react-query';
import axiosInstance from '../utils/axiosInstance';

export const useApi = ({ url, params = {}, key = 'data' }) => {
  return useQuery({
    queryKey: [key, url, params],
    queryFn: async () => {
      const response = await axiosInstance.get(url, { params });
      return response.data;
    },
    keepPreviousData: true,
  });
};

export const useMutationApi = ({ url, method = 'POST', key='data' }) => {
    // intialize queryClient
    const queryClient = new QueryClient();
  return useMutation({
    mutationFn: async (data) => {
      const response = await axiosInstance({ method, url, data });
      return response.data;
    },
    //invalidate and refetch the data after the mutation is successful
    onSettled: () => {
      queryClient.invalidateQueries(key);
    },
  });
};
